// Where "up" goes from a document opened in an index. Apart from the tree's
// column so the routes can say it without loading the column's code.
import type { DocIndexNodeDTO } from "@trameria/core/doc-indexes-shared";
import type { DocumentPaths } from "../place";
import { flat, siblingsOf } from "./queries";

/** Where the Dock's "up" goes from a document opened in the index: its parent's row, or the index. */
export function indexUpPath(
  paths: DocumentPaths,
  indexKey: string,
  nodes: readonly DocIndexNodeDTO[] | undefined,
  openKey: string,
): string {
  const open = flat(nodes ?? []).find((n) => n.key === openKey);
  const parent = open ? siblingsOf(nodes ?? [], open.pageId)?.parent : null;
  return parent
    ? paths.indexDocument(indexKey, parent.key)
    : paths.index(indexKey);
}
